/**
 * The vehicle profile's Maintenance tab (SWOOP-309). It is the path the module registry declares for the
 * tab (`modules.ts`, Maintenance → profile-tab), so the route guard and `<ModuleGate>` look it up there.
 */
export const VEHICLE_MAINTENANCE_PATH = '/vehicles/$vehicleId/overview/maintenance';
